import React from "react";

import YoutubeSvg from '../global/Svg/Youtube'
import MastodonSvg from '../global/Svg/Mastodon'
import PixelfedSvg from '../global/Svg/Pixelfed'
import InstagramSvg from '../global/Svg/Instagram'

const Social = () => {
    return (
        <>
            <a aria-label="Profil Youtube" href='https://www.youtube.com/@N47' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <YoutubeSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Mastodon" href='https://mastodon.art/@n47' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <MastodonSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Pixelfed" href='https://pixelfed.social/N47' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <PixelfedSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Instagram" href='https://www.instagram.com/n47/' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <InstagramSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
        </>
    )
}

export default Social